import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import {
  AlertWarningModule,
  ButtonModule,
  FormAlertModule,
  InputModule
} from '@com-delta-idp/mnx-ui-kit';
import { LoginHeaderModule } from '../../shared/login-header/login-header.module';
import { CreateMyPasswordComponent } from './create-my-password.component';

@NgModule({
  declarations: [CreateMyPasswordComponent],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    InputModule,
    FormAlertModule,
    AlertWarningModule,
    LoginHeaderModule,
    ButtonModule
  ],
  exports: [CreateMyPasswordComponent]
})
export class CreateMyPasswordModule {}
